/* eslint-disable @typescript-eslint/no-non-null-assertion */
import type { Operation, RequestHandler } from '@apollo/client';
import { Kind } from 'graphql';
import type { OperationDefinitionNode } from 'graphql/language/ast';

const NAME = 'skipCache';

const getShouldSkipCache = (operation: Operation): boolean => {
    const directives =
        (
            operation.query.definitions.find(
                (definition) => definition.kind === Kind.OPERATION_DEFINITION,
            ) as OperationDefinitionNode
        )?.directives ?? [];
    const cacheDirective = directives.find(
        (directive) => directive.name?.value === NAME,
    );
    if (typeof cacheDirective === 'undefined') {
        /**
         * if directive does not exist
         * then it's not enabled
         */
        return false;
    }

    const argument = cacheDirective?.arguments?.find(
        (argument) => argument.name?.value === 'if',
    )?.value;

    if (!argument) {
        /**
         * if directive is present but no argument is passed
         * then it's enabled
         */
        return true;
    }

    if (argument.kind === Kind.BOOLEAN) {
        return argument.value;
    }

    if (argument.kind === Kind.VARIABLE) {
        const varName = argument.name.value;
        return operation.variables[varName] as boolean;
    }

    throw new Error('@skipCache directive should be a Boolean or a Variable');
};
export const skipCacheDirective: { requestHandler: RequestHandler } = {
    requestHandler: (operation, next): ReturnType<RequestHandler> => {
        if (getShouldSkipCache(operation)) {
            operation.setContext({
                headers: {
                    'cache-control': 'no-cache',
                },
            });
        }

        return next(operation) as ReturnType<RequestHandler>;
    },
};
